import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=56442970&scoped=true"
import script from "./FeatureList.vue?vue&type=script&lang=js"
export * from "./FeatureList.vue?vue&type=script&lang=js"
import style0 from "./FeatureList.vue?vue&type=style&index=0&id=56442970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56442970",
  null
  
)

export default component.exports